import React, { Component } from 'react';
import "../../about-us/hero/heroSecond.css";
import ProjectInfo from "./info-cityplay";
import {Helmet} from "react-helmet";


class Cityplay extends Component {

    render() {

        return (

            <div id="portfolio-details">

                <Helmet>
                    <meta charSet="utf-8" />
                    <title>CityPlay | Tele Go</title>
                    <link rel="canonical" href="http://telego.rs/cityplay" />
                    <meta name="description" content="CityPlay is a music streaming platform released by a record label and one of the most popular music streaming services in the Balkans."/>
                </Helmet>

                <ProjectInfo />
            </div>

        );
    }
}

export default Cityplay;
